/**
 * Generate unique request ID for tracking
 */

export function generateRequestId(): string {
  return crypto.randomUUID();
}
